import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import PostCard from "../../components/PostCard";
import { useHomePage } from "../../contexts/HomePage";
import InfiniteScroll from "react-infinite-scroll-component";
import { LOADING, SUCCESS } from "../../constants/common";
import CardLoader from "../../components/CardLoader";
import { useAuth } from "../../contexts/Auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import paths from "../../constants/paths";

const InfiniteScrollPage = () => {
  const { fetchPosts, fetchPostsStatus, posts, fetchSummaryPosts } = useHomePage();

  const { account_type } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState({ page: 1 });
  const [hasMore, setHasMore] = useState(true);

  // Get URL parameters
  const frequency = searchParams.get("filter_range");
  const start_date = searchParams.get("filter_date_start");
  const end_date = searchParams.get("filter_date_end") || undefined;

  const fetchNextPage = async () => {
    if (fetchPostsStatus === SUCCESS && hasMore) {
      const nextPage = params.page + 1;
      setParams((prev) => ({ ...prev, page: nextPage }));
      await fetchSummaryPosts({
        page: nextPage,
        account_type,
        filter_range: frequency,
        filter_date_start: start_date,
        filter_date_end: end_date,
      });
    }
  };

  useEffect(() => {
    fetchSummaryPosts({
      ...params,
      account_type,
      filter_range: frequency,
      filter_date_start: start_date,
      filter_date_end: end_date,
    });
  }, [params.page, account_type, frequency, start_date, end_date]);

  useEffect(() => {
    if (posts?.last_page && params.page >= posts.last_page) {
      setHasMore(false);
    }
  }, [posts, params.page]);

  const handleGoToHomepage = () => {
    navigate(paths.home);
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          py: 3,
        }}
      >
        <InfiniteScroll
          dataLength={params.page * (posts.per_page || 0)}
          next={fetchNextPage}
          hasMore={
            params.page < posts.last_page && fetchPostsStatus !== LOADING
          }
          style={{
            overflow: "visible",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
          loader={
            fetchPostsStatus === LOADING && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            )
          }
        >
          {fetchPostsStatus === LOADING && params.page === 1 ? (
            <CardLoader />
          ) : (
            posts?.data.map((item) => <PostCard data={item} key={item.id} />)
          )}
        </InfiniteScroll>

        {!hasMore && posts?.data?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button
              variant="contained"
              onClick={handleGoToHomepage}
              sx={{
                px: 4,
                py: 1.5,
              }}
            >
              Go to Homepage
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default InfiniteScrollPage;
